import { defineComponent as h, useSlots as k, openBlock as t, createElementBlock as o, unref as i, renderSlot as a, createElementVNode as r, normalizeClass as g, createBlock as $, resolveDynamicComponent as C, createVNode as c, withCtx as m, createCommentVNode as d, createTextVNode as S, toDisplayString as u } from "vue";
import y from "./ghl-ui.es160.js";
import "./ghl-ui.es22.js";
import v from "./ghl-ui.es65.js";
const w = { class: "hl-modal-heading" }, B = { key: 0 }, D = { key: 1 }, H = {
  key: 0,
  class: "hl-icon-container"
}, N = { class: "action" }, V = { class: "title" }, q = {
  key: 0,
  class: "action"
}, b = { key: 1 }, E = {
  key: 2,
  class: "description"
}, I = h({
  __name: "ModalHeader",
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: void 0
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  emits: ["close"],
  setup(e) {
    const f = {
      custom: "icon-custom",
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    }, l = k();
    return (n, s) => (t(), o("div", w, [
      i(l).customHeader ? (t(), o("div", B, [
        a(n.$slots, "customHeader")
      ])) : (t(), o("div", D, [
        e.icon ? (t(), o("div", H, [
          r("div", {
            class: g(["icon", f[e.type]])
          }, [
            (t(), $(C(e.icon)))
          ], 2),
          r("div", N, [
            c(i(v), {
              circle: "",
              quaternary: "",
              onClick: s[0] || (s[0] = (p) => n.$emit("close")),
              id: `${e.id}-modal-close-btn`
            }, {
              default: m(() => [
                c(i(y), { class: "w-5 h-5" })
              ]),
              _: 1
            }, 8, ["id"])
          ])
        ])) : d("", !0),
        r("div", V, [
          S(u(e.title) + " ", 1),
          e.icon ? d("", !0) : (t(), o("div", q, [
            c(i(v), {
              circle: "",
              quaternary: "",
              onClick: s[1] || (s[1] = (p) => n.$emit("close")),
              id: `${e.id}-modal-close-btn`
            }, {
              default: m(() => [
                c(i(y), { class: "w-6 h-6" })
              ]),
              _: 1
            }, 8, ["id"])
          ]))
        ]),
        i(l).customDescription ? (t(), o("div", b, [
          a(n.$slots, "customDescription")
        ])) : e.description ? (t(), o("div", E, u(e.description), 1)) : d("", !0)
      ]))
    ]));
  }
}), z = I;
export {
  z as default
};
